<template>
  <div v-if="userPermission">
    <b-form>
      <div>
        <b-tabs no-nav-style nav-class="secondary-tabs">
          <b-tab
            :title="$t('tabs.general')"
            class="p-5"
            @click.prevent="updateVisibleSubmit(true)"
          >
            <products-form :viewIsLoading="loading" />
          </b-tab>
          <edit-actions
            route-name="productsList"
            :is-visible-submit="isVisibleSubmit"
            @save="submit"
          />
        </b-tabs>
      </div>
    </b-form>
  </div>
  <div
    v-else
    class="w-100 h-100 d-flex align-items-center justify-content-center"
  >
    <p class="fs-18 font-weight-bold">
      {{ $t("messages.dont_have_permission") }}
    </p>
  </div>
</template>

<script>
import productsForm from '@/components/products/form'
import editActions from '@/components/common/editActions'
import model from '@/models/products'
import edit from '@/mixins/edit'
import permissions from '@/mixins/permissions'
import api from '@/api/products'

export default {
  components: {
    productsForm,
    editActions
  },
  mixins: [edit, permissions],
  data: () => ({
    api,
    model: JSON.parse(JSON.stringify(model.empty)),
    rules: model.rules,
    isVisibleSubmit: true,
    loading: false
  }),
  created() {
    this.init()
  },
  methods: {
    async init() {
      this.loading = true

      if (this.$route.params.id) {
        await this.getItem()
      } else {
        this.initForm(this.model)
      }

      this.loading = false
    },
    updateVisibleSubmit(value) {
      this.isVisibleSubmit = value
    }
  },
  validations: {
    ...model.rules
  }
}
</script>

